import { ComponentType, lazy } from "react";

export interface WidgetDefinition {
	id: string;
	label: string;
	description: string;
	component: ComponentType;
	defaultEnabled: boolean;
	defaultOrder: number;
	alwaysVisible?: boolean;
	colSpan?: 1 | 2;
}

const BlockageOverviewWidget = lazy(() =>
	import("./widgets/BlockageOverviewWidget").then(m => ({ default: m.BlockageOverviewWidget })),
);
const IAndIVolumeWidget = lazy(() =>
	import("./widgets/IAndIVolumeWidget").then(m => ({ default: m.IAndIVolumeWidget })),
);
const MonitoringCoverageWidget = lazy(() =>
	import("./widgets/MonitoringCoverageWidget").then(m => ({ default: m.MonitoringCoverageWidget })),
);
const EventTimelineWidget = lazy(() =>
	import("./widgets/EventTimelineWidget").then(m => ({ default: m.EventTimelineWidget })),
);
const ConnectivityCoverageWidget = lazy(() =>
	import("./widgets/ConnectivityCoverageWidget").then(m => ({ default: m.ConnectivityCoverageWidget })),
);
const FlowConfigurationWidget = lazy(() =>
	import("./widgets/FlowConfigurationWidget").then(m => ({ default: m.FlowConfigurationWidget })),
);

export const WIDGET_REGISTRY: WidgetDefinition[] = [
	{
		id: "blockage-overview",
		label: "Blockages",
		description: "Current blockage status and top blocked structures",
		component: BlockageOverviewWidget,
		defaultEnabled: true,
		defaultOrder: 2,
	},
	{
		id: "iandi-volume",
		label: "Infiltration & Inflow",
		description: "Infiltration and inflow volume breakdown",
		component: IAndIVolumeWidget,
		defaultEnabled: true,
		defaultOrder: 3,
	},
	{
		id: "event-timeline",
		label: "Event Activity",
		description: "Event frequency heatmap",
		component: EventTimelineWidget,
		defaultEnabled: true,
		defaultOrder: 4,
	},
	{
		id: "monitoring-coverage",
		label: "Monitoring Coverage",
		description: "Network monitoring coverage across blockages and I&I",
		component: MonitoringCoverageWidget,
		defaultEnabled: true,
		defaultOrder: 5,
	},
	{
		id: "connectivity-coverage",
		label: "Connectivity",
		description: "Manhole pipe connectivity progress",
		component: ConnectivityCoverageWidget,
		defaultEnabled: true,
		defaultOrder: 6,
	},
	{
		id: "flow-configuration",
		label: "Configuration",
		description: "Flow parameter configuration progress for manholes",
		component: FlowConfigurationWidget,
		defaultEnabled: true,
		defaultOrder: 7,
	},
];
